module.exports = __webpack_public_path__ + "img/BB.22a6f0df.png";